module.exports = __webpack_public_path__ + "img/business_28.3facc7b7.jpg";